<table class="table table-responsive" *ngIf="historicos; else carregando">
    <thead>
        <tr>
            <th scope="col">Data</th>
            <th scope="col">Estado</th>
            <th scope="col">Motivo</th>
            <th scope="col">Responsável</th>
        <tr>
    </thead>
    <tbody>
        <tr *ngFor="let hist of historicos">
            <td>{{ hist?.dataUltimaAtualizacao | date:'dd/MM/yyyy HH:mm'}}</td>
            <td>{{ hist?.estado?.nomeEstado }}</td>
            <td>{{ hist?.estado?.motivoEstado}}</td>
            <td>{{ hist?.nomeUsuarioResponsavel}}</td>
        </tr>
    </tbody>
</table>


<ng-template #carregando>
    <div class="loading-pesquisa">
        <i class="bn-loading"></i>
    </div>
</ng-template>